import type { IconProps } from './types';

export const ChevronLeftDoubleIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M20.9062 2.15625L11.0625 12L20.9062 21.8438M13.4062 2.15625L3.5625 12L13.4062 21.8438"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
